import Vue from 'vue';
import { VueperSlides, VueperSlide } from 'vueperslides'

import 'es6-promise/auto';

import VueLoadScript from 'vue-load-script-plus'
Vue.use(VueLoadScript);

if (document.getElementById('app')) {
    const app = new Vue(
        {
            el: '#app',
            components: {
                'vueper-slides': VueperSlides,
                'vueper-slide': VueperSlide,
            }
        }
    )
}
